<template>
 <main>
    <section class="bg-white dark:bg-staticsecondary-900 ">
      <div class="container flex items-center justify-center min-h-screen w-full px-6 py-12">
        <div>
          <base-logo :filename="logo" alt="EdasInvoiZE" class="mb-6"/>
          <h1 class="mt-3 text-2xl font-semibold text-staticsecondary dark:text-white md:text-3xl">{{ $t('feedback.error.redirection_error') }}</h1>
            <p class="mt-4 text-staticsecondary-600 dark:text-staticsecondary-400">{{ $t('feedback.error.redirection_error_long') }}</p>
            <p class="mt-4 text-staticsecondary-600 dark:text-staticsecondary-400">{{ $t('feedback.info.retry_and_contact_msg') }}</p>
            <div class="flex items-center mt-6 gap-x-3">
              <router-link :to="{ name: 'login' }">
                  <base-button 
                mode="staticprimary"
                :text="$t('app.ppal_page')" 
                />
              </router-link>
            </div>
        </div>
      </div>
    </section>
  </main>
</template>
<script>
export default {
  computed: {
    darkMode: function () {
      return this.$store.getters['app/darkMode']
    },
    logo: function () {
      if (this.darkMode) {
        return 'logo-edasinvoize-dark.webp'
      }
      return 'logo-edasinvoize.webp'
    },
  },
}
</script>
